import { shopfrontSlugFromHost } from './utils/shopfrontHost';
import { MarketingAuthProvider } from './contexts/MarketingAuthContext';
import RouteBoundary from './components/RouteBoundary';
import React, { lazy, Suspense } from 'react';
import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import '@whoppatix/contracts/tokens.css';
import './index.css';
import './productTheme.css';
import '@whoppatix/contracts/motion.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from "@vercel/speed-insights/react";
import MicrosoftClarity from '@microsoft/clarity';

const Landing = lazy(() => import('./pages/landing/Landing'));
const NoMatch = lazy(() => import('./pages/nomatch/NoMatch'));

const Privacy = lazy(() => import('./pages/privacy/Privacy'));
const Terms = lazy(() => import('./pages/terms/Terms'));
const EventSalePage = lazy(() => import('./pages/events/EventSalePage'));
const ShopfrontPreviewPage = lazy(() => import('./pages/shopfront/ShopfrontPreviewPage'));
const ShopfrontPage = lazy(() => import('./pages/shopfront/ShopfrontPage'));
const OrganizerRedirectPage = lazy(() => import('./pages/shopfront/OrganizerRedirectPage'));
const BlogIndex = lazy(() => import('./pages/blog/BlogIndex'));
const BlogPost = lazy(() => import('./pages/blog/BlogPost'));

const isWebsitePreview = window.location.pathname === '/shopfront-preview';
if (!isWebsitePreview) MicrosoftClarity.init('wq0bhpw45x');

const rootElement = document.getElementById("root");

render(
  <HelmetProvider>
    <BrowserRouter>
      <MarketingAuthProvider>
      <ToastContainer autoClose={600} />
      <RouteBoundary><Suspense fallback={<main className="wt-events-page"><p role="status">Loading page…</p></main>}>
      <Routes>
        <Route exact path="/" element={shopfrontSlugFromHost(window.location.hostname) ? <ShopfrontPage domainSlug={shopfrontSlugFromHost(window.location.hostname)} /> : <Landing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/events/:eventId" element={<EventSalePage />} />
        <Route path="/shopfront-preview" element={<ShopfrontPreviewPage />} />
        <Route path="/o/:slug" element={<ShopfrontPage />} />
        <Route path="/organizers/:organizerId" element={<OrganizerRedirectPage />} />
        <Route path="*" element={<NoMatch />} />
      </Routes>
      </Suspense></RouteBoundary>
      {!isWebsitePreview && <Analytics />}
      {!isWebsitePreview && <SpeedInsights />}
      </MarketingAuthProvider>
    </BrowserRouter>
  </HelmetProvider>,
  rootElement
);
